var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "findingsToolbar" },
        },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.projectUploadVexModal",
                  modifiers: { projectUploadVexModal: true },
                },
                {
                  name: "permission",
                  rawName: "v-permission:or",
                  value: [
                    _vm.PERMISSIONS.VIEW_VULNERABILITY,
                    _vm.PERMISSIONS.VULNERABILITY_ANALYSIS,
                  ],
                  expression:
                    "[\n        PERMISSIONS.VIEW_VULNERABILITY,\n        PERMISSIONS.VULNERABILITY_ANALYSIS,\n      ]",
                  arg: "or",
                },
              ],
              attrs: {
                id: "apply-vex-button",
                size: "md",
                variant: "outline-primary",
              },
            },
            [
              _c("span", { staticClass: "fa fa-upload" }),
              _vm._v(" " + _vm._s(_vm.$t("message.apply_vex")) + "\n    "),
            ]
          ),
          _c(
            "b-tooltip",
            { attrs: { target: "apply-vex-button", triggers: "hover focus" } },
            [_vm._v(_vm._s(_vm.$t("message.apply_vex_tooltip")))]
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission:or",
                  value: [
                    _vm.PERMISSIONS.VIEW_VULNERABILITY,
                    _vm.PERMISSIONS.VULNERABILITY_ANALYSIS,
                  ],
                  expression:
                    "[\n        PERMISSIONS.VIEW_VULNERABILITY,\n        PERMISSIONS.VULNERABILITY_ANALYSIS,\n      ]",
                  arg: "or",
                },
              ],
              attrs: {
                id: "export-vex-button",
                size: "md",
                variant: "outline-primary",
              },
              on: {
                click: function ($event) {
                  return _vm.downloadVex()
                },
              },
            },
            [
              _c("span", { staticClass: "fa fa-download" }),
              _vm._v(" " + _vm._s(_vm.$t("message.export_vex")) + "\n    "),
            ]
          ),
          _c(
            "b-tooltip",
            { attrs: { target: "export-vex-button", triggers: "hover focus" } },
            [_vm._v(_vm._s(_vm.$t("message.export_vex_tooltip")))]
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission:or",
                  value: [
                    _vm.PERMISSIONS.VIEW_VULNERABILITY,
                    _vm.PERMISSIONS.VULNERABILITY_ANALYSIS,
                  ],
                  expression:
                    "[\n        PERMISSIONS.VIEW_VULNERABILITY,\n        PERMISSIONS.VULNERABILITY_ANALYSIS,\n      ]",
                  arg: "or",
                },
              ],
              attrs: {
                id: "export-vdr-button",
                size: "md",
                variant: "outline-primary",
              },
              on: {
                click: function ($event) {
                  return _vm.downloadVdr()
                },
              },
            },
            [
              _c("span", { staticClass: "fa fa-download" }),
              _vm._v(" " + _vm._s(_vm.$t("message.export_vdr")) + "\n    "),
            ]
          ),
          _c(
            "b-tooltip",
            { attrs: { target: "export-vdr-button", triggers: "hover focus" } },
            [_vm._v(_vm._s(_vm.$t("message.export_vdr_tooltip")))]
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission:or",
                  value: [_vm.PERMISSIONS.VIEW_VULNERABILITY],
                  expression: "[PERMISSIONS.VIEW_VULNERABILITY]",
                  arg: "or",
                },
              ],
              attrs: {
                id: "reanalyze-button",
                size: "md",
                variant: "outline-primary",
              },
              on: {
                click: function ($event) {
                  return _vm.reAnalyze()
                },
              },
            },
            [
              _c("span", { staticClass: "fa fa-refresh" }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.project_reanalyze")) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "b-tooltip",
            { attrs: { target: "reanalyze-button", triggers: "hover focus" } },
            [_vm._v(_vm._s(_vm.$t("message.project_reanalyze_tooltip")))]
          ),
          _c(
            "c-switch",
            _vm._b(
              {
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: {
                  id: "showSuppressedFindings",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.showSuppressedFindings,
                  callback: function ($$v) {
                    _vm.showSuppressedFindings = $$v
                  },
                  expression: "showSuppressedFindings",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.$t("message.show_suppressed_findings"))),
          ]),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: { "on-load-success": _vm.tableLoaded },
      }),
      _c("project-upload-vex-modal", { attrs: { uuid: this.uuid } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }